import Konva from 'konva';
import { createdByType } from '../../Pages/Flo/Flo.types';
import { Profile } from '../../Containers/Routes/Routes.types';

export enum ActionType {
	addComment = 'add-comment',
	pauseAndShow = 'pause-and-show',
	none = 'none',
}

export enum AnnotationToolType {
	rect = 'rect',
	freeHand = 'free-hand',
	eraser = 'eraser',
}

export interface AnnotationElement {
	key: string;
	id?: string;
	commentId?: string;
	createdBy?: createdByType;
	time: number;
	comment?: {
		content: string;
	};
	tool: string;
	windowSize: {
		height: number;
		width: number;
		offsetWidth: number;
		offsetHeight: number;
	};
}

export interface AnnotationElementRect extends AnnotationElement {
	x?: number;
	y?: number;
	width?: number;
	height?: number;
}

export interface AnnotationElementFreeHand extends AnnotationElement {
	points?: number[];
}

export type AnnotationState = AnnotationElementRect & AnnotationElementFreeHand;

export interface AnnotationSnapshot {
	count: number;
	time: number;
	id?: string;
	uid?: string;
	uiId?: string;
	commentId?: string;
	comment?: string;
	userDetails: annotationUserDetailsType;
	user?: string;
	state: AnnotationState[];
}

export type setAnnotationsByTimeType = {
	data: AnnotationSnapshot[];
	commentId?: string;
	floId: string;
	floIndex: number;
};
export interface AnnotationMetaSnapshot {
	count: number;
	time: number;
	id?: string;
	userDetails: annotationUserDetailsType;
	user?: string;
}

export type annotationUserDetailsType = {
	firstName: string;
	name: string;
	userProfile: string;
};

export type CropAreaType = {
	x: number;
	y: number;
	x2: number;
	y2: number;
	windowSize: {
		width: number;
		height: number;
	};
};

export interface AnnotationProps {
	tool: string;
	actionType: ActionType.addComment | ActionType.pauseAndShow | 'crop' | string;
	showData?: AnnotationMetaSnapshot;
	elements?: AnnotationState[];
	player: HTMLVideoElement | undefined;
	className?: string;
	offsetWidth?: number;
	enable?: boolean;
	allowComment?: boolean;
	doNotSetTop?: boolean;
	isFloClosed?: boolean;
	isImage?: boolean;
	offsetHeight?: number;
	width?: number;
	height?: number;
	addingComment?: boolean;
	currentUser: Profile;
	areaSelected?: CropAreaType;
	videoSize: {
		width: number;
		height: number;
	};

	onDone?(data: AnnotationSnapshot, event: Konva.KonvaEventObject<MouseEvent>): void;
	continuePlay?(): void;
	onAnnotationProgress?(isInProgress: boolean): void;
	onAnnotationClick?(id?: string): void;
	onAreaSelected(area: CropAreaType): void;
	floId: string;
	floIndex: number;
}
